// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"b4a431be","220":"81c8a1c4","373":"a36e0cf0","569":"c543ed32","595":"12918549","966":"73b9151a"}[chunkId] + ".chunk.js";
};